export default __webpack_public_path__ + "static/media/chevron_double_right.f8a749f7.svg";